import { getUserFromCookie } from '@nike/ciclp-utils/cookies';
import createReducer from '../../../utils/createReducer';
import { bootstrapActions } from '../../../actions';

export default createReducer(null, {
  [bootstrapActions.request.type]: state => getUserFromCookie() || state,
});
